//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapMutations, mapState } from 'vuex';
import ClickOutside from '@/directives/ClickOutside';
import { LOGOUT, LOGOUT_OF_ACCOUNT } from '@/store/types/actions';
import { PERSISTENCE_SET } from '@/store/types/mutations';
import { ACCOUNT, AUTH, PERSISTENCE } from '@/store/types/namespaces';

export default {
  name: 'NavigationUser',
  directives: { ClickOutside },
  props: {
    state: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      showBackupImage: false,
    };
  },
  computed: {
    ...mapState(AUTH, ['picture', 'givenName']),
    ...mapState(ACCOUNT, ['name']),
    ...mapState([PERSISTENCE]),
  },
  methods: {
    ...mapActions(AUTH, [LOGOUT, LOGOUT_OF_ACCOUNT]),
    ...mapMutations(PERSISTENCE, [PERSISTENCE_SET]),
    handleSwitchAccount() {
      this[LOGOUT_OF_ACCOUNT]();
    },
    handleLogout() {
      this[LOGOUT]('manual');
    },
  },
};
